import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';
import EvolutionIcon from '../EvolutionIcon';

const IndicatorBoxContainer = styled.div`
  padding: 20px;
  border: 1px solid rgba(173, 181, 189, 0.2);
  border-radius: 4px;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  color: ${(props) => props.theme.colors.dark};
  font-size: 12px;
  line-height: 1.5;
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
  }

  .title {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    font-size: 20px;

    span {
      color: rgba(31, 43, 55, 0.5);
      font-size: 12px;
      margin-left: 5px;
      font-family: ${(props) => props.theme.fonts.sfcompact_text};
      text-transform: uppercase;
    }
  }

  .iconContainer {
    margin-left: 10px;
  }

  ${(props) => props.styles}
`;

const IndicatorBox = ({ title, icon, evolution, content, styles }) => (
  <IndicatorBoxContainer styles={styles}>
    <div className="header">
      <h1 className="title">{title}</h1>
      <div className="iconContainer">
        {icon && evolution ? (
          <EvolutionIcon icon={icon} />
        ) : (
          icon && <Icon icon={icon} />
        )}
      </div>
    </div>
    {content}
  </IndicatorBoxContainer>
);

export default IndicatorBox;
